import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../components/common/Card";
import PageHeader from "../../components/common/PageHeader";
import Table from "../../components/common/Table";
import Button from "../../components/common/Button";
import { removeHeldOrder, clearHeldOrders } from "../../store/heldOrdersSlice";

const formatHeldAt = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

const HeldOrders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const heldOrders = useSelector((state) => state.heldOrders.orders) || [];

  const columns = [
    { key: "customer", label: "Customer" },
    { key: "mode", label: "Type" },
    { key: "heldAt", label: "Held At" },
    { key: "actions", label: "Actions" },
  ];

  const rows = useMemo(() => {
    return heldOrders.map((order) => ({
      id: order.id,
      customer: (
        <div className="space-y-0.5">
          <div className="font-semibold text-slate-900 dark:text-slate-100">
            {order.customerName || "Customer"}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400">
            {order.customerPhone || "-"}
          </div>
        </div>
      ),
      mode: order.mode || "-",
      heldAt: formatHeldAt(order.heldAt),
      actions: (
        <div className="flex items-center justify-end gap-2">
          <Button
            size="sm"
            variant="secondary"
            onClick={() => dispatch(removeHeldOrder(order.id))}
          >
            Remove
          </Button>
          <Button
            size="sm"
            onClick={() => {
              const resumePath = order.resumePath || "/pos";
              dispatch(removeHeldOrder(order.id));
              navigate(resumePath, {
                state: {
                  resumedHeldOrder: order,
                },
              });
            }}
          >
            Resume
          </Button>
        </div>
      ),
    }));
  }, [dispatch, heldOrders, navigate]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Held Orders"
        subtitle="Resume an order that was held from POS."
        actions={
          heldOrders.length > 0 ? (
            <Button
              size="sm"
              variant="secondary"
              onClick={() => dispatch(clearHeldOrders())}
            >
              Clear All
            </Button>
          ) : null
        }
      />

      <Card>
        <Table columns={columns} rows={rows} emptyText="No held orders." />
      </Card>
    </div>
  );
};

export default HeldOrders;

